const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-tile-container'] = {
        c: () => require('partner/modules/dlvry-tile-container/dlvry-tile-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-tile-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-tile-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };